var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "47px",
    viewBox: "0 0 63 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,44.4 L63,47 L52.4780562,47 L52.4780562,44.4 L54.674512,44.4 C55.3531774,44.4 55.7398588,43.9372 55.518898,43.3028 L54.2746781,39.7382 L48.406064,39.7382 L46.8935345,35.6042 L52.9304998,35.6042 L49.3477779,25.004 L46.3121971,33.9766 L44,27.4818 L46.4226776,21 L52.2676173,21 L60.2458812,43.1416 C60.5378652,43.9606 60.8877198,44.4 61.7663021,44.4 L63,44.4 L63,44.4 Z M47.3684211,41.7777778 L50,41.7777778 L50,47 L31.5789474,47 L31.5789474,41.7777778 L32.9789474,41.7777778 C34.1868421,41.7777778 35.0368421,40.5949444 34.6447368,39.4617222 L32.4973684,33.9444444 L16.0973684,33.9444444 L13.9526316,39.4617222 C13.5605263,40.5949444 14.4105263,41.7777778 15.6184211,41.7777778 L18.4210526,41.7777778 L18.4210526,47 L0,47 L0,41.7777778 L1.13157895,41.7777778 C2.69210526,41.7777778 4.08684211,40.7986111 4.60526316,39.3363889 L19.0973684,0 L29.4973684,0 L43.9894737,39.3363889 C44.5078947,40.7986111 45.8052632,41.7777778 47.3684211,41.7777778 Z M19,26 L30,26 L24.136621,10 L19,26 Z",
    id: "Shape",
    fill: "#828282",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBlock);
export default __webpack_public_path__ + "static/media/TextBlock.ae97d4fa.svg";
export { ForwardRef as ReactComponent };